import { Validators } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import { CutOffEffects } from '../../../../effects/cut-off.effects';
import { SetProjectPropertiesCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-project-properties.command';
// product form field
import { ProductsDisablerOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/product-enabler.provider';
import { RmsChildrenStrategies } from '../../../../models/rms-children-strategies';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { QuantityOpenPlatformProvider } from '../../../../providers/open-platform/quantity.provider';
import { ResetSlotOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/reset-slot.command.service';
import { QuantityWarningOpenPlatformProvider } from '../../../../providers/open-platform/quantity-warning.provider';
import { SpacingDisabledProvider } from '../../../../providers/spacing-disabled.provider';
import { PumpRmsULProvider } from '@ordersnproducts/modules/shared/modules/pump-rms-ul/services/pump-rms-ul.provider';
import { LoadProductAddedRMXULValues } from '../../../../services/config-loader/commands/open-platform/load-added-value-rmx-ul.command.service';
import { PumpableProjectProfilesRMXULOptionLoader } from '../../../../services/config-loader/loaders/pumpable-project-profile-rmx-ul.service.loader';
import { FormTextAreaComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-textarea/form-textarea.component';
import { SpecFieldClasses } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-classes.enum';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';
import { AdjustmentCheckboxCommandCO } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/co-adjustment-checkbox.command.service';
import { HandleCoUnloadTypeCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-co-unload-type.command.service';
import { PaymentTermsByJobsiteLoaderService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/payment-terms-by-jobsite-loader.service';
import { ContractProductsOptionLoaderService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/contract-products.loader.service';
import { SpacingOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/spacing-option-loader.service';
import { RmsColombiaProductsEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/colombia-products.effects';
import { UnloadTypeOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/unload-type-option-loader.service';
import { PumpOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/pump-option-loader.service';
import { ApplicationOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/application-option-loader.service';
import { LoadSizeOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/load-size-option-loader.service';

export const RMS_UL = {
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: 'id',
      placeholder: 'id',
      hidden: true,
      visible: false,
    } as FieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ContractProductsOptionLoaderService,
      loading: ProductsDisablerOpenPlatformProvider.IsLoading,
      // filter: true,
      // onFilterChange: ProductOptionsSearchOpenPlatformService,
      validation: [Validators.required],
      dynamicEffects: [CutOffEffects, RmsColombiaProductsEffects],
      placeholder: 'views.specifications.select_product',
      onChange: [ResetSlotOpenPlatformCommandService, LoadProductAddedRMXULValues],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      containerClassNames: ['field-11x field-md-4x retail-control '],
      name: SpecFieldNames.QUANTITY,
      dataTId: SpecFieldTestIds.QUANTITY,
      value: QuantityOpenPlatformProvider.DefaultValue,
      min: 0.01,
      step: 1,
      max: 99999,
      suffix: UNITS.CUBIC_METERS,
      validation: [Validators.required],
      warningMessage: QuantityWarningOpenPlatformProvider.IsLargeOrderMessageQuantity,
      decimals: 1,
      onChange: [ResetSlotOpenPlatformCommandService, AdjustmentCheckboxCommandCO],
    } as FieldInputNumberConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.ADJUSTMENT,
      dataTId: SpecFieldTestIds.ADJUSTMENT,
      value: false,
      containerClassNames: ['field-6x field-md-2x retail-control input-number-align'],
      placeholder: 'views.specifications.Adjustment',
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.paymentTerms',
      name: SpecFieldNames.PAYMENT_TERMS,
      dataTId: SpecFieldTestIds.PAYMENT_TERMS,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      disabled: true,
      validation: [Validators.required],
      optionsLoader: PaymentTermsByJobsiteLoaderService,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.project_profiles',
      name: SpecFieldNames.PROJECT_PROFILES,
      dataTId: SpecFieldTestIds.PROJECT_PROFILES,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_projectProfiles',
      optionsLoader: PumpableProjectProfilesRMXULOptionLoader,
      onChange: [SetProjectPropertiesCommand],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: ApplicationOptionLoader,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
      onChange: [],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: SpacingOptionLoader,
      validation: [Validators.required],
      onChange: [ResetSlotOpenPlatformCommandService],
      disabled: SpacingDisabledProvider.Disabled,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.load_size',
      name: SpecFieldNames.LOAD_SIZE,
      dataTId: SpecFieldTestIds.LOAD_SIZE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.load_size',
      optionsLoader: LoadSizeOptionLoader,
      validation: [Validators.required],
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.unload_type',
      optionsLoader: UnloadTypeOptionLoader,
      onChange: [HandleCoUnloadTypeCommand],
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.pump_capacity',
      name: SpecFieldNames.PUMP,
      dataTId: SpecFieldTestIds.PUMP,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_pumpCapacity',
      optionsLoader: PumpOptionLoader,
      validation: [Validators.required],
      hidden: PumpRmsULProvider.ValidatorPumpCapacityCO,
      disabled: PumpRmsULProvider.ValidatorPumpCapacityCO,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.pipe_quantity',
      containerClassNames: ['field-12x field-md-3x retail-control'],
      name: SpecFieldNames.PIPE_QUANTITY,
      dataTId: SpecFieldTestIds.PIPE_QUANTITY,
      min: 0,
      value: 0,
      step: 1,
      hidden: PumpRmsULProvider.ValidatorPipeQuantityCO,
    } as FieldInputNumberConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.CLEAN_UP,
      dataTId: SpecFieldTestIds.CLEAN_UP,
      value: false,
      containerClassNames: [SpecFieldClasses.CLEAN_UP],
      placeholder: 'views.specifications.kicker',
      validation: [],
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormTextAreaComponent,
      label: 'views.specifications.additional_info',
      name: SpecFieldNames.ADDITIONAL_INFO,
      dataTId: SpecFieldTestIds.ADDITIONAL_INFO,
      containerClassNames: [SpecFieldClasses.ADDITIONAL_INFO],
      placeholder: '',
      maxlength: '500',
      validation: [],
    } as FieldConfig,
  ],
  chidlrenStrategies: [RmsChildrenStrategies.MasterContract, RmsChildrenStrategies.MasterDate],
} as RmsFormConfig;
